var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"position-relative util-content pa-4",attrs:{"data-cy":"utilsContent-div-content"}},[_vm._t("header"),_vm._t("content"),_vm._t("actions")],2)}
var staticRenderFns = []

export { render, staticRenderFns }